import type { ReactNode } from "react"
import { TanStackDevtools } from "@tanstack/react-devtools"
import { QueryClientProvider } from "@tanstack/react-query"
import { ReactQueryDevtools, ReactQueryDevtoolsPanel } from "@tanstack/react-query-devtools"
import { queryClient } from "./client"

const QueryProvider = ({ children }: { children: ReactNode }) => {
  return (
    <QueryClientProvider client={queryClient}>
      {/* @ts-expect-error TODO(FE-01): @types/react version mismatch (17 vs 19 from TanStack) — remove when React upgraded */}
      {children}
      {/*<TanStackDevtools
        config={{ hideUntilHover: true, triggerHidden: true }}
        plugins={[{ name: "ReactQuery", render: <ReactQueryDevtoolsPanel /> }]}
      />*/}
      {/*<ReactQueryDevtools initialIsOpen={false} panelPosition="bottom" />*/}
    </QueryClientProvider>
  )
}

export default QueryProvider
